import {update_cart} from './_cart';

document.addEventListener("DOMContentLoaded", async function() {

    //if we're on the cart page
	if(document.body.classList.contains('page-template-page-cart')) {

        //fetch all invalid tyres on the page
        let invalid_tyres = document.querySelectorAll('.cart_item[validity="invalid"]');

        //if we have invalid tyres
        if(invalid_tyres && invalid_tyres.length > 0) {

            //loop over the invalid tyres
            for(let i = 0; i < invalid_tyres.length; i++) {

                //fetch the tyre
                let tyre = invalid_tyres[i];

                //fetch the ID of this tyre
                let id = tyre.querySelector('.qty').dataset.id;

                //fetch the requested quantity
                let quantity = tyre.querySelector('.qty').value;

                //attempt a cart update, this will trigger the stock check and enquiry modal
                await update_cart(id, quantity);
            }

            //fetch the current URL
            let url = new URL(window.location.href);

            //remove the invalid query string
            url.searchParams.delete('invalid_tyres');

            //update the URL
            window.history.pushState({}, document.title, url);
        }
    }
});